import {AbstractControl} from "@angular/forms";

// A missing control is treated as valid so a mistyped control name hides an error instead of throwing.
export function isControlInvalid(control: AbstractControl | null): boolean {
    return !!control && control.invalid && (control.dirty || control.touched);
}
